import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueJwtDecode from "vue-jwt-decode";
import cookie from "js-cookie";
import CryptoJS from "crypto-js";
import $ from "jquery";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: "",
    refresh: cookie.get("medmon_refresh"),
    user: {},
    filter_date_from: cookie("medmon_filter_date_from")
      ? cookie("medmon_filter_date_from")
      : moment()
        .set({ hour: "00", minute: "00", second: "00" })
        .subtract(6, "days"),
    filter_date_to: cookie("medmon_filter_date_to")
      ? cookie("medmon_filter_date_to")
      : moment().set({ hour: "23", minute: "59", second: "59" }),
    filter_topic: cookie("medmon_filter_topic")
      ? cookie("medmon_filter_topic")
      : { id: "all", text: "Pilih Topik Media Online" },
    filter_topic_sna: cookie("medmon_filter_topic_sna")
      ? cookie("medmon_filter_topic_sna")
      : { id: "all", text: "Pilih Topik Media Sosial" },
    filter_group: cookie("medmon_filter_group")
      ? cookie("medmon_filter_group")
      : { id: "all", text: "Semua Grup" },
    filter_validate: cookie("medmon_filter_validate")
      ? cookie("medmon_filter_validate")
      : "Semua Data",
    filter_cakupan: cookie("medmon_filter_cakupan")
      ? cookie("medmon_filter_cakupan")
      : "Semua Cakupan",
    theme: "dark-mode",
    floating_loader: false,
    isFiltter: false,
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token, user) {
      state.status = "success";
      state.token = token;
      state.user = user;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {};
      state.refresh = false;
    },
    set_login(state, user_session) {
      state.user = user_session;
      state.status = "success";
    },
    set_token(state, token) {
      state.token = token;
    },
    set_filter_date(state, date_filter) {
      state.filter_date_from = date_filter.from;
      state.filter_date_to = date_filter.to;
      state.isFiltter = date_filter.isFilter;
    },
    set_filter_topic(state, topic) {
      state.filter_topic = topic;
    },
    set_filter_topic_sna(state, topic) {
      state.filter_topic_sna = topic;
    },
    set_filter_group(state, group) {
      state.filter_group = group;
    },
    set_filter_validate(state, is_validated) {
      state.filter_validate = is_validated;
    },
    set_filter_cakupan(state, cakupan) {
      state.filter_cakupan = cakupan;
    },
    set_theme(state, theme) {
      state.theme = theme;
    },
    set_project(state, project) {
      state.user.project = project;

      let refresh_decode = VueJwtDecode.decode(state.refresh);
      let refresh_exp = refresh_decode.exp * 1000;
      let cookie_expire = new Date(refresh_exp);
      let user_data = CryptoJS.AES.encrypt(
        JSON.stringify(state.user),
        process.env.VUE_APP_HASH_KEY
      ).toString();
      cookie.set("medmon_user", user_data, { expires: cookie_expire });
    },
    set_loading(state, loading) {
      state.floating_loader = loading;
    },
    set_channel(state, channel) {
      state.user.project.project_detail.crawler = channel;
    },
  },
  actions: {
    login({ commit }, user) {
      // let remember_me = user.remember;
      let api = process.env.VUE_APP_API_URL + "login";
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({ url: api, data: user, method: "POST" })
          .then((resp) => {
            if (resp.status == 200) {
              const token = resp.data["access-token"];
              const refresh = resp.data["refresh-token"];

              let token_decode = VueJwtDecode.decode(token);
              let token_exp = token_decode.exp * 1000;
              let token_expire = new Date(token_exp);
              cookie.set("medmon_ref", token, { expires: token_expire });

              let refresh_decode = VueJwtDecode.decode(refresh);
              let refresh_exp = refresh_decode.exp * 1000;
              let cookie_expire = new Date(refresh_exp);

              var now = new Date();
              now.setTime(now.getTime() + 24 * 7 * 3600 * 1000); //set cookie seminggu

              cookie.set("medmon_refresh", refresh, { expires: cookie_expire });
              // cookie.set('medmon_remember', 0);

              axios.defaults.headers.common["token"] = token;

              let api =
                process.env.VUE_APP_API_URL +
                "project-detail/" +
                resp.data.user.id_project;
              axios({ url: api, data: {}, method: "GET" })
                .then((response) => {
                  // if (response.data.project_detail.tipe == 1 || response.data.project_detail.tipe == 2) {

                  // delete data not use for medmon_user and project_detail
                  delete response.data.project_detail.alias
                  delete response.data.project_detail.crawler.instagram.hashtags
                  delete response.data.project_detail.crawler.tiktok.hashtags
                  delete response.data.project_detail.crawler.instagram.hashtags_id
                  delete response.data.project_detail.crawler.facebook.tracked_pages
                  delete response.data.project_detail.crawler.linkedin.tracked_pages
                  delete response.data.project_detail.socmed_creds.twitter.oauth_token
                  delete response.data.project_detail.socmed_creds.twitter.oauth_token_reset
                  delete response.data.project_detail.socmed_creds.twitter.oauth_refresh_toekn
                  delete response.data.project_detail.socmed_creds.twitter.user_id
                  delete response.data.project_detail.socmed_creds.facebook.token
                  delete response.data.project_detail.socmed_creds.facebook.account_id
                  delete response.data.project_detail.socmed_creds.facebook.instagram_id
                  delete response.data.project_detail.socmed_creds.facebook.message
                  delete response.data.project_detail.socmed_creds.facebook.status

                  let user_detail = resp.data.user;
                  user_detail.project = response.data;
                  user_detail.role = token_decode.role;
                  let user_data = CryptoJS.AES.encrypt(
                    JSON.stringify(user_detail),
                    process.env.VUE_APP_HASH_KEY
                  ).toString();
                  cookie.set("medmon_user", user_data, {
                    expires: cookie_expire,
                  });
                  commit("auth_success", token, user_data);
                  commit("set_login", user_detail);
                  resolve(resp.data["access-token"]);
                  // }else {
                  // console.log(Vue.router)
                  // }
                })
                .catch((error) => {
                  console.log(error);
                  resp.data.user.role = token_decode.role;
                  let user_data = CryptoJS.AES.encrypt(
                    JSON.stringify(resp.data.user),
                    process.env.VUE_APP_HASH_KEY
                  ).toString();
                  commit("auth_success", token, user_data);
                  resolve(resp.data["access-token"]);
                });
            } else {
              reject(resp.data);
            }
          })
          .catch((err) => {
            console.log(err);
            commit("auth_error");
            cookie.remove("medmon_ref");
            // localStorage.removeItem('medmon_ref')
            reject(err.response);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("logout");
        cookie.remove("medmon_ref");
        cookie.remove("medmon_refresh");
        cookie.remove("medmon_user");
        if (delete axios.defaults.headers.common["token"]) {
          resolve();
        } else {
          reject();
        }
      });
    },
    setLogin({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          let user_session = CryptoJS.AES.decrypt(
            cookie.get("medmon_user"),
            process.env.VUE_APP_HASH_KEY
          );
          let user_data = user_session.toString(CryptoJS.enc.Utf8);
          let user_data_obj = JSON.parse(user_data);
          let token = cookie.get("medmon_ref");

          commit("set_token", token);
          commit("set_login", user_data_obj);
          resolve(token);
        } catch (e) {
          console.log(e);
          reject();
        }
      });
    },
    renewToken({ commit }) {
      return new Promise((resolve, reject) => {
        if (cookie.get("medmon_refresh")) {
          let api = process.env.VUE_APP_API_URL + "renew-access";
          let userID = this.getters.user.user_id.$oid;
          let data = {
            "refresh-token": cookie.get("medmon_refresh"),
            uid: userID,
          };

          axios
            .post(api, data)
            .then((response) => {
              if (response.status == 200) {
                let token = response.data["access-token"];
                let token_decode = VueJwtDecode.decode(token);
                let token_exp = token_decode.exp * 1000;
                let token_expire = new Date(token_exp);
                cookie.set("medmon_ref", token, { expires: token_expire });
                commit("set_token", token);
                $.ajaxSetup({
                  headers: { token: token },
                });
                resolve(token);
              } else {
                reject(response);
              }
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          reject("gagal refresh tidak tersedia");
        }
      });
    },
    set_date_filter({ commit }, date_filter, isFilter) {
      commit("set_filter_date", date_filter, isFilter);
    },
    set_topic_filter({ commit }, topic) {
      commit("set_filter_topic", topic);
    },
    set_topic_filter_sna({ commit }, topic) {
      commit("set_filter_topic_sna", topic);
    },
    set_group_filter({ commit }, group) {
      commit("set_filter_group", group);
    },
    set_validate_filter({ commit }, is_validated) {
      commit("set_filter_validate", is_validated);
    },
    set_cakupan_filter({ commit }, cakupan) {
      commit("set_filter_cakupan", cakupan);
    },
    set_theme({ commit }, theme) {
      commit("set_theme", theme);
    },
    user_project({ commit }, project) {
      commit("set_project", project);
    },
    change_channel({ commit }, id_project) {
      let api = process.env.VUE_APP_API_URL + "project-detail/" + id_project;
      axios({ url: api, data: {}, method: "GET" })
        .then((response) => {
          let channel = response.data.project_detail.crawler;
          commit("set_channel", channel);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loading({ commit }, status = true) {
      commit("set_loading", status);
    },
  },
  modules: {},
  getters: {
    isLoggedIn: (state) => !!state.refresh,
    authStatus: (state) => state.status,
    user: (state) => state.user,
    filter_channel: (state) => state.user.project.project_detail.crawler,
    token: (state) => state.token,
    filter_date_from: (state) => state.filter_date_from,
    filter_date_to: (state) => state.filter_date_to,
    filter_topic: (state) => state.filter_topic,
    filter_topic_sna: (state) => state.filter_topic_sna,
    filter_group: (state) => state.filter_group,
    filter_validate: (state) => state.filter_validate,
    filter_cakupan: (state) => state.filter_cakupan,
    theme: (state) => state.theme,
    floating_loader: (state) => state.floating_loader,
    isFiltter: (state) => state.isFiltter,
  },
});
